    const tabsespd = document.querySelectorAll('.tabs__btnpd');
    const tabsContent = document.querySelectorAll('.tabs__bodypd');

    if (tabsContent.length > 0 || tabs.length > 0) {

        function hideTabContent() {
            tabsContent.forEach(item => {
                item.classList.remove('active');
            });

            tabsespd.forEach(item => {
                item.classList.remove('active');
            });
        }

        function showTabContent(i = 0) {
            tabsContent[i].classList.add('active');
            tabsespd[i].classList.add('active');
        }

        hideTabContent();
        showTabContent();

        tabsespd.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                hideTabContent();
                showTabContent(index);
            });
        });
    }

// // Select all elements with the class "questions"
// const questions = document.querySelectorAll(".questions");

// // Add the "active" class to the first element to make it active by default
// if (questions.length > 0) {
//   questions[0].classList.add("active");
//   const firstAnswer = questions[0].nextElementSibling;
//   firstAnswer.style.maxHeight = firstAnswer.scrollHeight + "px";
// }

// // Add click event listeners to toggle the active state and show/hide answers
// questions.forEach(question => {
//   question.addEventListener("click", event => {
//     const active = document.querySelector(".questions.active");
//     if (active && active !== question) {
//       active.classList.toggle("active");
//       active.nextElementSibling.style.maxHeight = 0;
//     }
//     question.classList.toggle("active");
//     const answer = question.nextElementSibling;
//     if (question.classList.contains("active")) {
//       answer.style.maxHeight = answer.scrollHeight + "px";
//     } else {
//       answer.style.maxHeight = 0;
//     }
//   });
// });


document.addEventListener("DOMContentLoaded", function () {
	const accordionItems = document.querySelectorAll(".mobile-view .q-ans");
 accordionItems[0].classList.add("active");
	accordionItems.forEach((item) => {
		const button = item.querySelector(".questions");
		const content = item.querySelector(".answercont");

		button.addEventListener("click", function () {

			item.classList.toggle("active");
			if (item.classList.contains("active")) {

				content.style.maxHeight = content.scrollHeight + "px";
			} else {
				content.style.maxHeight = null;
			}
		});
	});
});




document.addEventListener('DOMContentLoaded', function() {
    // Check if the element with data-simple-bundles-options attribute exists
    var element = document.querySelector('[data-simple-bundles-options]');

    // If the element exists
    if (element) {
        // Remove main-quantity-atc class
        var mainQuantityAtc = element.closest('.main-quantity-atc');
        if (mainQuantityAtc) {
            mainQuantityAtc.classList.remove('main-quantity-atc');
        }
        
        // Add abcd class to main-quantity
        var mainQuantity = document.querySelector('.custom-bundles');
        if (mainQuantity) {
            mainQuantity.classList.add('custom-bundles-align');
        }
    } else {
        // If the element doesn't exist, add abcd class to main-quantity
        var mainQuantity = document.querySelector('.custom-bundles');
        if (mainQuantity) {
            mainQuantity.classList.add('custom-bundles-align');
        }
    }
});


